import { LogoSpotifyForArtists, VisuallyHidden } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';

import { StyledTextLink } from './StyledTextLink';

const S4ALogo = styled(LogoSpotifyForArtists)`
  display: block;
`;

const label = 'Spotify for Artists';

export const NavigationBrand = () => (
  <StyledTextLink href="https://artists.spotify.com/home?ref=logo">
    <S4ALogo label={label} height={36} />
    <VisuallyHidden>{label}</VisuallyHidden>
  </StyledTextLink>
);
